import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import axios from 'axios';
import LocationResultArea from './sub/LocationResultArea';
import ballObj from '../../utils/ball/ballObj';
import _ from 'lodash';

function LocationResultMain({profile, leagueType = 4201}) {
    const [cookies] = useCookies(['hiball_token']);
    let dateObj = dateSetting();

    let [ballCodeArr, setBallCodeArr] = useState([]);

    useEffect(() => {

        let pitcherPitchRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'futuresRecordService',
                recordName: 'futuresPitcherTrackManRecord',
                seasons: dateObj['season'],
                pitcherIds: profile['playerId'],
                groupingColumn: 'ballType',
                authToken:JSON.stringify(cookies['hiball_token']),
                gameTypeCode: leagueType
                // gameTypeCode: 4206
            }
        })

        Promise.all([
            pitcherPitchRecord
        ]).then((response) => {
            let pitchData = _.filter(response[0]['data']['result'], (item) => {
                item['ballName'] = ballObj[item['taggedPitchType']]['name'];
                return (item['taggedPitchType'] !== 'Other') && (item['taggedPitchType'] !== '-');
            });

            setBallCodeArr(prevItems => [...prevItems, ...pitchData]);
        })
    }, []);

    return (
    <>
    <LocationResultArea profile={profile} ballCodeArr={ballCodeArr} leagueType={leagueType}/>
    </>
    ) 
}

export default LocationResultMain;